export default __webpack_public_path__ + "static/media/dashboard.82a815cf.png";